import { FormFeedBack, ModalBase, STATUSPAGE } from '@repo/ui';
import { GetByIdTaskResponse } from 'domain/models';
import {
  TaskCreateUseCaseInterface,
  TaskGetByIdUseCaseInterface,
  TaskUpdateUseCaseInterface,
} from 'domain/usecases';
import { useFormik } from 'formik';
import { Row, Col, Form, Label, Input } from 'reactstrap';

interface IProps {
  isOpen: boolean;
  toggleModal: () => void;
  taskByIdSelected: TaskGetByIdUseCaseInterface.Result;
  requestTaskUpdate: (
    params: TaskUpdateUseCaseInterface.Params,
  ) => Promise<void>;
  requestTaskCreate: (
    params: TaskCreateUseCaseInterface.Params,
  ) => Promise<void>;
  validationFormTask: ReturnType<typeof useFormik>;
  taskId: string;
  setTaskByIdSelected: (task: GetByIdTaskResponse | null) => void;
  clearNavigationState: () => void;
  loadingTaskById: STATUSPAGE;
  loadingCreateOrEditTask: STATUSPAGE;
}

export const ModalNewTask = ({
  toggleModal,
  setTaskByIdSelected,
  isOpen,
  taskId,
  clearNavigationState,
  loadingTaskById,
  loadingCreateOrEditTask,
  validationFormTask: formik,
}: IProps) => {
  // Helper functions
  const toggleAndResetForm = () => {
    toggleModal();
    formik.resetForm();
    setTaskByIdSelected(null);
  };

  return (
    <ModalBase.Wrapper
      loading={loadingTaskById === STATUSPAGE.LOADING}
      isOpen={isOpen}
      size="lg"
      toggle={() => {
        toggleAndResetForm();
        clearNavigationState();
      }}
    >
      <ModalBase.Header
        withBorderBottom
        toggle={() => {
          toggleAndResetForm();
          clearNavigationState();
        }}
      >
        {taskId ? 'Editar Tarefa' : 'Nova Tarefa'}
      </ModalBase.Header>
      <Form autoComplete="off" onSubmit={formik.handleSubmit}>
        <ModalBase.Body>
          <Row>
            <Col md={12}>
              <Label htmlFor="name" className="form-label">
                Nome
              </Label>
              <Input
                id="name"
                type="text"
                autoFocus
                name="name"
                className="form-control"
                value={formik.values.name}
                onChange={formik.handleChange}
                invalid={formik.touched.name && !!formik.errors.name}
              />
              <FormFeedBack
                error={formik.errors.name as any}
                isInvalid={formik.touched.name && !!formik.errors.name}
              />
            </Col>
            <Col className="mt-2" md={12}>
              <Label htmlFor="description" className="form-label">
                Descrição
              </Label>
              <Input
                rows={4}
                id="description"
                type="textarea"
                name="description"
                className="form-control"
                onBlur={formik.handleBlur}
                value={formik.values.description}
                onChange={formik.handleChange}
              />
            </Col>
            <Col className="mt-2" md={12}>
              <Label htmlFor="feedback" className="form-label">
                Pergunta do feedback da atividade
              </Label>
              <Input
                id="feedback"
                type="text"
                name="feedback"
                className="form-control"
                onBlur={formik.handleBlur}
                value={formik.values.feedback}
                onChange={formik.handleChange}
              />
            </Col>

            <Col className="mt-2" md={12}>
              <Label htmlFor="description" className="form-label">
                Resposta obrigatória ?
              </Label>
              <div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="responseRequiredYes"
                    name="responseRequired"
                    onBlur={formik.handleBlur}
                    value="true"
                    onChange={() =>
                      formik.setFieldValue('responseRequired', true)
                    }
                    checked={formik.values.responseRequired === true}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="responseRequiredYes"
                  >
                    Sim
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="responseRequiredNo"
                    name="responseRequired"
                    onBlur={formik.handleBlur}
                    value="false"
                    onChange={() =>
                      formik.setFieldValue('responseRequired', false)
                    }
                    checked={formik.values.responseRequired === false}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="responseRequiredNo"
                  >
                    Não
                  </label>
                </div>
                <FormFeedBack
                  error={formik.errors.responseRequired as any}
                  isInvalid={
                    formik.touched.responseRequired &&
                    !!formik.errors.responseRequired
                  }
                />
              </div>
            </Col>
          </Row>
        </ModalBase.Body>
        <ModalBase.Footer>
          <ModalBase.Actions
            actionBtnType="submit"
            goBack={toggleAndResetForm}
            loading={loadingCreateOrEditTask === STATUSPAGE.LOADING}
          />
        </ModalBase.Footer>
      </Form>
    </ModalBase.Wrapper>
  );
};
